import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const MiscGrnViewSingle = () => {
   useAuthRedirect();
  const { grnNo } = useParams();
  const branch = localStorage.getItem("branch");
  const [poDetail, setPoDetail] = useState({});
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [poNo, setPoNo] = useState("");

  const [subDetails, setSubDetails] = useState({});
  const canView  = hasPermission("Branch office GRN", "view");

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/miscgrn_detailsHeader?grnNo=${grnNo}&branch=${branch}`
        );
        if (response.data && response.data.headerDetails?.length > 0) {
          const items = response.data.headerDetails;

          const storeReqHeader = {
            grnheader_date: items[0].grnheader_date,
            grnheader_suppliercode: items[0].grnheader_suppliercode,
            grnheader_DcNumber: items[0].grnheader_DcNumber,
            grnheader_DcDate: items[0].grnheader_DcDate,
            grnheader_invoiceNumber: items[0].grnheader_invoiceNumber,
            grnheader_invoiceDate: items[0].grnheader_invoiceDate,
          };

          setPoDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [grnNo, branch]);

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${poDetail.grnheader_suppliercode}`
        );
        const items = response.data.supDetails;
        const storeReqHeaderCity = {
          supplierMaster_code: items[0].supplierMaster_code,
          supplierMaster_name: items[0].supplierMaster_name,
          supplierMaster_addressline1:
            items[0].supplierMaster_addressline1,
          supplierMaster_addressline2:
            items[0].supplierMaster_addressline2,
          supplierMaster_city: items[0].supplierMaster_city,
          supplierMaster_pincode: items[0].supplierMaster_pincode,
        };
        setSubDetails(storeReqHeaderCity);
        // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [poDetail.grnheader_suppliercode]);


const [loading, setLoading] = useState(true);

useEffect(() => {
  setLoading(true); // Start loading
  axios
    .get(
      `https://rfs2.infraconsoft.net.in/api/miscgrn_detailsBottom?branch=${branch}&grnNo=${grnNo}`
    )
    .then((response) => {
      if (response.data && response.data.headerDetails2) {
        setData(response.data.headerDetails2);

        if (response.data.headerDetails2.length > 0) {
          setPoNo(response.data.headerDetails2[0].grnDetail_poNumber);
        }
      } else {
        setData([]);
        setPoNo("");
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
      setData([]);
      setPoNo("");
    })
    .finally(() => {
      setLoading(false); // Stop loading
    });
}, [branch, grnNo]);


  useEffect(() => {
    if (poNo) {
      axios
        .get(
          `https://rfs2.infraconsoft.net.in/api/grn_scheduleDetails?branch=${branch}&grnNo=${grnNo}&poNo=${poNo}`
        )
        .then((response) => {
          if (response.data && response.data.headerDetails3) {
            setData1(response.data.headerDetails3);
          } else {
            setData1([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setData1([]);
        });
    }
  }, [branch, grnNo, poNo]);

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
                    <div className="back-div">
                    <h2 className="add-txt">Goods Receipt Note - View</h2>
                    <Link to='/inventory/miscGrnView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form">
            <div className="form-row">
              <div className="form-group">
                <label>GRN No :</label>
                <input type="text" name="PoNumber" value={grnNo} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input
                  type="text"
                  name="endhrs"
                  value={
                    poDetail.grnheader_date
                      ? new Date(poDetail.grnheader_date).toLocaleDateString(
                          "en-GB"
                        )
                      : ""
                  }
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input
                  type="text"
                  name="scode"
                  value={subDetails.supplierMaster_code}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input
                  type="text"
                  name="sname"
                  value={subDetails.supplierMaster_name}
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>DC No :</label>
                <input
                  type="text"
                  name="yourRefNo"
                  value={poDetail.grnheader_DcNumber}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>DC Date :</label>
                <input
                  type="text"
                  name="endhrs"
                  value={
                    poDetail.grnheader_DcDate
                      ? new Date(poDetail.grnheader_DcDate).toLocaleDateString(
                          "en-GB"
                        )
                      : ""
                  }
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input
                  type="text"
                  name="ourRefNo"
                  value={poDetail.grnheader_invoiceNumber}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input
                  type="text"
                  name="endhrs"
                  value={
                    poDetail.grnheader_invoiceDate
                      ? new Date(
                          poDetail.grnheader_invoiceDate
                        ).toLocaleDateString("en-GB")
                      : ""
                  }
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input
                  type="text"
                  name="address1"
                  value={subDetails.supplierMaster_addressline1}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input
                  type="text"
                  name="address2"
                  value={subDetails.supplierMaster_addressline2}
                  readOnly
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input
                  type="text"
                  name="city"
                  value={subDetails.supplierMaster_city}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input
                  type="text"
                  name="pincode"
                  value={subDetails.supplierMaster_pincode}
                  readOnly
                />
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Unit Price</th>
                    <th>P.O pending Qty</th>
                    <th>DC Qty</th>
                    <th>Acc Qty</th>
                    <th>Rej Qty</th>
                  </tr>
                </thead>
                <tbody>
  {loading ? (
    <tr>
      <td colSpan="9">Loading...</td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.grnDetail_itemcode}</td>
        <td>{item.itemmaster_name}</td>
        <td>{item.itemmaster_drawingNumber}</td>
        <td>{item.itemMaster_purchaseUom}</td>
        <td>{item.grnDetail_price}</td>
        <td>{item.grnDetail_poPendingQuantity}</td>
        <td>{item.grnDetail_DcQuantity}</td>
        <td>{item.grnDetail_packedQuantity}</td>
        <td>{item.GrnDetail_ExcessShortageQuantity}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9">No items</td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MiscGrnViewSingle;
